export default __webpack_public_path__ + "static/media/postage.5436cc3c.png";